export const arCaptchaKeys = process.env.VUE_APP_ARCAPTCHA_CREDENTIALS
